// extracted by mini-css-extract-plugin
module.exports = {"pointer":"Pointer_pointer__QDGTT","pulse":"Pointer_pulse__1DWl4"};